import React, { FC } from 'react';
import styles from './innerheader.module.css';
import './header-bugger.scss';
import { NavLink } from 'react-router-dom';
import { Menu } from '../Menu';

const mainDomain =
  process.env.REACT_APP_GROUP_URL || 'https://www.ohyagroup.com';

export const InnerPageHeader: FC = () => {
  return (
    <>
      <div className={`max-w-[1920px] mx-auto ${styles.frame} z-10 bugger`}>
        <div className={styles.img}>
          <input type="checkbox" id="menuToggle"></input>

          <label htmlFor="menuToggle" className="menuOpen">
            <div className="open"></div>
          </label>
          <div className="menu menuEffects">
            <label htmlFor="menuToggle"></label>
            <Menu />
          </div>
        </div>
        <NavLink to={mainDomain + '/'}>
          <img
            className={styles.logo}
            alt="Element"
            src="/assets/images/pages/2-5-3-4.svg"
          />
        </NavLink>
        <div className={styles.img} />
        {/* <img
          className={styles.img}
          alt="Account circle"
          src="/assets/images/home/account-circle-dark.png"
        /> */}
      </div>
    </>
  );
};
